<script setup>
import { useErrorsStore } from '@/Stores/errors'
const errors = useErrorsStore()

const props = defineProps({
    organisation: {
        type: Object,
        default: () => ({}),
    },
})

function cancelAccount() {
    errors.confirms.push({
        title: "Cancel Account",
        message: "This will send a membership cancellation request to Advance Cairns. Are you sure?",
        type: "danger",
        btnText: "Request Cancellation",
        onConfirm: doRequestCancellation
    });
}

function doRequestCancellation(){
    axios.post(route('dashboard.organisations.request-cancellation', props.organisation.id))
    .then((response) => {
        errors.push({
            title: 'Success',
            message: 'Cancellation request sent. A member of our team will be in contact with you shortly.',
            type: 'success'
        })
    })
    .catch(error => {
        errors.push({
            type: 'error',
            title: "Couldn't send cancellation request!",
            message: error.response.data.message,
        })
    })
}
</script>

<template>

    <SectionCard title="Cancel Membership">
        <p class="text-sm">If you would like to cancel your organisations membership, click the 'Request Cancellation' button below.</p>
        <template #footer>
            <Button @click="cancelAccount" color='red'>Request Cancellation</Button>
        </template>
    </SectionCard>
    
</template>